import InterestForm from "./InterestForm";

export default InterestForm;